// Customers List State

export default {
  customersList: [],
  customerInfo: {},
  fullCustomersList: [],
  saleCustomersList: []
}
